import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import { Input, Select, DatePicker, InputMoney, Form } from "@/components/Form";
import { Page, DashboardContainer, Row, Col } from "@/components/Grid";
import { AdminMenu } from "@/components/Admin";
import { Navbar } from "@/components/Blocks";
import { Button } from "@/components/Common";
import { SelectSearch } from "@/components/Form";
import { useBoletos } from "@/hooks";
import toastify from "@/services/toastify";

import { schema } from "./schemas";
import {
  Header,
  FormContainer,
  FormSection,
} from "./styles";

function GerarBoleto({ history }) {
  const { createBoleto } = useBoletos();
  const [formData, setFormData] = useState({
    data_vencimento: "",
    amount: ""
  });
  const [loading, setLoading] = useState(false);

  function handleEmpresaChange(empresa_id) {
    setFormData(state => {
      return { ...state, ...{ empresa_id } };
    });
  }

  function mapOptionsEmpresas(data) {
    return data.map(empresa => ({
      id: empresa.id,
      title: empresa.nome_exibicao || empresa.nome_fantasia
    }));
  }

  async function handleSubmit(data) {
    setLoading(true);

    const payload = {
      empresa_id: parseInt(data.empresa_id, 10),
      data_vencimento: data.data_vencimento.toISOString().split("T")[0], // Format date to YYYY-MM-DD
      amount: data.amount
    };

    const response = await createBoleto(payload);
    setLoading(false);

    if (response.success) {
      toastify("Boleto gerado com sucesso!");
      history.push("/admin/boletos");
    } else {
      toastify(response.message || "Erro ao gerar boleto", "error");
    }
  }

  function handleCancel() {
    history.push("/admin/boletos");
  }

  return (
    <Page>
      <Navbar type="interna" />
      <AdminMenu />
      <DashboardContainer>
        <Header>
          <h4>Financeiro</h4>
          <h2>Gerar novo boleto</h2>
          <div className="breadcrumbs">
            Financeiro {">"} Boletos {">"} <span>Gerar novo boleto</span>
          </div>
        </Header>

        <FormContainer>
          <FormSection>
            <Form schema={schema} onSubmit={handleSubmit} initialData={formData}>
              <Row hascols>
                <Col>
                  <SelectSearch
                    label="Empresa"
                    endpoint="empresas"
                    searchParam="nome"
                    mapOptions={mapOptionsEmpresas}
                    onChange={handleEmpresaChange}
                    name="empresa_id"
                    value={formData.empresa_id}
                  />
                </Col>
              </Row>

              <Row hascols>
                <Col md="1/2">
                  <Input
                    type="date"
                    name="data_vencimento"
                    label="Data de vencimento"
                  />
                </Col>
                <Col md="1/2">
                  <InputMoney
                    name="amount"
                    label="Valor"
                    placeholder="R$ 0,00"
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <div style={{ display: "flex", gap: "16px", marginTop: "24px" }}>
                    <Button
                      type="submit"
                      variant="cyan"
                      loading={loading}
                      disabled={loading}
                    >
                      Gerar Boleto
                    </Button>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={handleCancel}
                      disabled={loading}
                    >
                      Cancelar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </FormSection>
        </FormContainer>
      </DashboardContainer>
    </Page>
  );
}

export default withRouter(GerarBoleto);
